import Component from '@glimmer/component';
import type { Signature as BaseCancerFormSignature } from '../base-cancer-form';
import BaseCancerForm from '../base-cancer-form';

interface Signature {
  Args: Pick<BaseCancerFormSignature['Args'], 'form' | 'patient'>;
}

export default class MedicalHistoryFormStomachCancerDiagnosticFieldsComponent extends Component<Signature> {
  BaseCancerForm = BaseCancerForm;

  <template>
    <this.BaseCancerForm @form={{@form}} @patient={{@patient}} />
  </template>
}
